export const global = {
  env: process.env.NODE_ENV,
  modal: {type:'confirm', header: 'Message', modalContent: null, onConfirm: null, onCancel: null, confirmText: "Confirm", cancelText: "Cancel"},
};
